import {Component, Input, OnInit} from '@angular/core';
import {EventGroupPageStateService} from "@biletix/features/event-group/services/event-group-page-state.service";
import {EventGroupListItem} from "@biletix/core/models/event/event-group-list-item.model";
import {EventService} from "@biletix/core/services/event.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {map} from "rxjs/operators";
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";

@Component({
    standalone: false,
    selector: 'btx-event-group-list',
    templateUrl: './event-group-list.component.html',
    styleUrls: ['./event-group-list.component.scss']
})
export class EventGroupListComponent extends AbstractionComponent implements OnInit {

    @Input() eventCode!: string;
    @Input() region?: string;
    @Input() lang?: string;
    @Input() eventList?: BtxPerformanceListItem[];

    //EventList: EventGroupListItem[] = [];


    constructor() {
        super();
    }

    ngOnInit() {
            //  this.eventService
            // .getPerformancesByEventCode(this.eventCode)
            // .subscribe(events => {

            //     if (events && events.length > 0) {
            //         //TODO: Status enum oluşturulmalı.
            //         events.forEach(item => item.active = item.status == 's01_onsale');
            //     }
            //     this.EventList = events;
            // });
    }

}
